(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eba-hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var $carousel = $('.custom-owl');
  if ($carousel.length) {
    $carousel.owlCarousel({
      loop: false,
      margin: 10,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      nav: false,
      dots: false,
      responsive: {
        0:   { items: 1 },
        600: { items: 1 },
        1000:{ items: 1 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
